import {
  Button,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Container,
  Card
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import 'react-quill/dist/quill.snow.css';
import { useState, useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import axios from 'axios';

const AddGotra = () => {
  const navigate = useNavigate();

  const [gotra, setGotra] = useState('');
  const [parentgotra, setparentgotra] = useState('');
  const [kuldevi, setkuldevi] = useState('');
  const [gotraErr, setGotraErr] = useState(false);
  const [kuldeviErr, setkuldeviErr] = useState(false);
  const [parentgotraErr, setparentgotraErr] = useState(false);

  const [allGotras, setAllGotras] = useState([]);

  const getallGotra = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/gotra/getAll`
      );
      const data = response?.data?.data;
      setAllGotras(data);
    } catch (err) {
      toast.error(err?.response?.data?.message, { position: 'bottom-right' });
    }
  };

  useEffect(() => {
    getallGotra();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check for empty fields
    let isError = false;
    if (gotra === '') {
      setGotraErr(true);
      isError = true;
    }

    if (isError) return; // Exit if there are validation errors

    try {
      // Make sure all fields are sent in the request
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/gotra/add`, {
        gotra,
        parentgotra,
        kuldevi
      });

      toast.success('Gotra Added Successfully!', { position: 'bottom-right' });
      navigate('/gotra');
    } catch (err) {
      toast.error(err?.response?.data?.message, { position: 'bottom-right' });
    }
  };

  return (
    <>
      <Container maxWidth="lg">
        <Card>
          <form
            onSubmit={handleSubmit}
            style={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              gap: '10',
              background: '#fff',
              padding: 15,
              margin: 30,
              borderRadius: 10
            }}
          >
            <div style={{ margin: 4, width: '100%' }}>
              <p
                style={{
                  margin: 4,
                  width: '100%',
                  color: '#000',
                  fontWeight: 700,
                  marginBottom: '30px',
                  fontSize: '25px'
                }}
              >
                Add Gotra
              </p>
            </div>

            {/* Gotra Field */}
            <div style={{ margin: 9, width: '47%' }}>
              <FormControl fullWidth>
                <TextField
                  id="outlined-required"
                  name="gotra"
                  value={gotra}
                  placeholder="Enter Gotra"
                  autoComplete="off"
                  onChange={(e) => {
                    setGotra(e.target.value);
                    setGotraErr(false);
                  }}
                />
                {gotraErr && (
                  <span
                    style={{
                      color: 'red',
                      display: 'flex',
                      paddingTop: '10px'
                    }}
                  >
                    This Field is required
                  </span>
                )}
              </FormControl>
            </div>

            {/* Parent Gotra Dropdown */}
            <div style={{ margin: 9, width: '47%' }}>
              <FormControl fullWidth>
                <InputLabel>Parent Gotra</InputLabel>
                <Select
                  value={parentgotra}
                  onChange={(e) => setparentgotra(e.target.value)}
                  label="Parent Gotra"
                >
                  {allGotras.map((option) => (
                    <MenuItem key={option._id} value={option.gotra}>
                      {option.gotra}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            {/* kuldevi Field */}
            <div style={{ margin: 9, width: '47%' }}>
              <TextField
                name="kuldevi"
                value={kuldevi}
                placeholder="Enter kuldevi"
                onChange={(e) => setkuldevi(e.target.value)}
                fullWidth
              />
            </div>

            {/* Submit Button */}
            <div style={{ margin: 9, width: '100%' }}>
              <Button variant="contained" type="submit">
                Submit
              </Button>
            </div>
          </form>
        </Card>
      </Container>
    </>
  );
};

export default AddGotra;
